export const Intensity = {
  NORMAL: 'normal',
  INTENSE: 'intense',
} as const;

export type PrankIntensity = typeof Intensity[keyof typeof Intensity];

export interface PrankDefinition {
  namedCode: string;
  hexCode: string;
  // eslint-disable-next-line no-unused-vars
  create: (intensity: PrankIntensity) => () => void;
}
